import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const helpCenterSettingsAnalyticsAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "async-help-center-settings-analytics-app" */ './src/ui');
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<{
			default: typeof import('./src/ui').default;
		}>;
	}),
	getPreloadProps: () => {
		return {};
	},
});
